import React from 'react'; //,{useState}
import '../App.css';
//server endpoint in local test deployment
//export const ENDPOINT = 'http://localhost:5000';

//server endpoint in live deployment
//export const ENDPOINT = 'https://open-dialogue.herokuapp.com';
export const ENDPOINT = 'https://ode-server.onrender.com';
export const EMAIL = 'ode.tudublin@gmail.com';

//keys of all experiments currently running
export const ActiveExperiments = ["ex1","ex2"];
export const Profile = {
  "title":"Demographic Info",
  "data":[
    { "id":"Age Group",
			"question":"Age Group:",
      "type":"radio",
      "options":["18-25","26-35","36-45","46-55","over 55"]
    },
    { "id":"Gender",
			"question":"Gender: ",
      "type":"radio",
      "options":["Female","Male","Other","Prefer not to say"]
    },
    { "id":"VR Experience",
			"question":"Experience with virtual characters/environments: ",
      "type":"radio",
      "options":["None","Consumer (games/movies/...)","Expert (researcher/programmer/...)"]
    },
    { "id":"Native Language",
			"question":"First/Native Language: ",
      "type":"shortText"
    },
    { "id":"Learning English (Years)",
			"question":"For how many years have you been learning English? (If English is your first language, please enter 'native')",
      "type":"shortText"
    }

  ]
};

export const Personality = {
  "title":"Personality Questionnaire",
  "instructions":"In the statements shown below, please rate from 1 (Very Wrong) to 5 (Very Right) how well each describes you as you generally are.",
  "type":"scale",
  "start":"Very Wrong",
  "end":"Very Right",
  "options":["1","2","3","4","5"],
  "data":[
    { "id":"Pers_E1+",
			"question":"I am the life of the party.",
    },
    { "id":"Pers_A1-",
			"question":"I feel little concern for others.",
    },
    { "id":"Pers_O1+",
			"question":"I have a rich vocabulary.",
    },
    { "id":"Pers_E2-",
			"question":"I don't talk a lot.",
    },
    { "id":"Pers_A2+",
			"question":"I am interested in people.",
    },
    { "id":"Pers_O2-",
			"question":"I have difficulty understanding abstract ideas.",
    },
    { "id":"Pers_E3+",
			"question":"I feel comfortable around people.",
    },
    { "id":"Pers_A3-",
			"question":"I insult people.",
    },
    { "id":"Pers_O3+",
			"question":"I have a vivid imagination.",
    },
    { "id":"Pers_E4-",
			"question":"I keep in the background.",
    },
    { "id":"Pers_A4+",
			"question":"I sympathize with others' feelings.",
    },
    { "id":"Pers_O4-",
			"question":"I am not interested in abstract ideas.",
    },
    { "id":"Pers_E5+",
			"question":"I start conversations.",
    },
    { "id":"Pers_A5-",
			"question":"I am not interested in other people's problems.",
    },
    { "id":"Pers_O5+",
			"question":"I have excellent ideas.",
    },
    { "id":"Pers_E6-",
			"question":"I have little to say.",
    },
    { "id":"Pers_A6+",
			"question":"I have a soft heart.",
    },
    { "id":"Pers_O6-",
			"question":"I do not have a good imagination.",
    },
    { "id":"Pers_E7+",
			"question":"I talk to a lot of different people at parties.",
    },
    { "id":"Pers_A7-",
			"question":"I am not really interested in others.",
    },
    { "id":"Pers_O7+",
			"question":"I am quick to understand things.",
    },
    { "id":"Pers_E8-",
			"question":"I don't like to draw attention to myself.",
    },
    { "id":"Pers_A8+",
			"question":"I take time out for others.",
    },
    { "id":"Pers_O8+",
			"question":"I use difficult words.",
    },
    { "id":"Pers_E9+",
			"question":"I don't mind being the center of attention.",
    },
    { "id":"Pers_A9+",
			"question":"I feel others' emotions.",
    },
    { "id":"Pers_O9+",
			"question":"I spend time reflecting on things.",
    },
    { "id":"Pers_E10-",
			"question":"I am quiet around strangers.",
    },
    { "id":"Pers_A10+",
			"question":"I make people feel at ease.",
    },
    { "id":"Pers_O10+",
			"question":"I am full of ideas.",
    }
  ]
};
export const BotChat=[
  <div className="center" >
    <h1 className="title">Chat</h1>
    <div className='instructions' style={{maxWidth: "600px",margin: "auto"}}>
    <p className="dark" style={{display: "block"}}></p>
    <div>
      <p>Please click the link below to begin your chat.</p>
      <p><a href="http://127.0.0.1:8000/p/1" target="_blank" rel="noreferrer">Enter Chat</a></p>
    </div>
    </div>
  </div>,
  <div className="center" >
    <h1 className="title">Chat</h1>
    <div className='instructions' style={{maxWidth: "600px",margin: "auto"}}>
    <p className="dark" style={{display: "block"}}></p>
    <div>
      <p>Please click the link below to begin your chat.</p>
      <p><a href="http://127.0.0.1:8000/p/2" target="_blank" rel="noreferrer">Enter Chat</a></p>
    </div>
    </div>
  </div>];
//This is a standatdised 10 item personality questionnaire
export const AvatarPersonality2 = {
  "title":"The Avatar's Personality",
  "instructions":<div>
  <p>Below are a number of personality traits that may or may not apply to the virtual human (Saoirse) you were just talking to.
  Please select the extent to which you agree or disagree with each statement from 1 (very wrong) to 7 (very right).
  You should rate the extent to which the pair of traits applies to Saoirse, even if one characteristic applies more strongly than the other.</p>
  <p>If you don't understand a word, click the (?) next to it for an explanation. </p>
  <p>Saoirse seems...</p>
  </div>,
  "type":"scale",
  "start":"Very Wrong",
  "end":"Very Right",
  "options":["1","2","3","4","5","6","7"],
  "data":[
    { "id":"E1+_Enthusiastic",
			"question":"Extroverted, enthusiastic",
      "description":"Lively and confident, and enjoying being with other people/ Feeling or showing a lot of excitement and interest about somebody/something",
    },
    { "id":"A1-_Critical",
			"question":"Critical, quarrelsome",
      "description":"Saying what you think is bad about somebody or something/ Often arguing with other people",
    },
    { "id":"C1+_Patient",
			"question":"Dependable, self-disciplined",
      "description":"Can be relied on/ Able to control the way you behave and to make yourself do things that you believe you should do",
    },
    { "id":"N1-_Anxious",
			"question":"Anxious, easily upset",
      "description":"Worried or nervous/ Often unhappy or disappointed because of something a little unpleasant",
    },
    { "id":"O1+_Open",
			"question":"Open to new experiences, complex",
      "description":"Willing to listen to or accept new ideas or suggestions/ A curious, intelligent, and imaginative person",
    },
    { "id":"E2-_Quiet",
			"question":"Reserved, quiet",
      "description":"Slow or unwilling to show feelings or express opinions/ Does not to talk very much",
    },
    { "id":"A2+_Warm",
			"question":"Sympathetic, warm",
      "description":"Showing that you understand and care about their problems/ Comforting and supportive",
    },
    { "id":"C2-_Careless",
			"question":"Disorganized, careless",
      "description":"Not able to plan or organize well/ Not giving enough attention and thought to what you are doing, so that you make mistakes",
    },
    { "id":"N2+_Calm",
			"question":"Calm, emotionally stable",
      "description":"Not nervous or upset/ Reasonable, not easily upset",
    },
    { "id":"O2-_Conventional",
			"question":"Conventional, uncreative",
      "description":"Normal and ordinary, and perhaps not very interesting/ Not very imaginative",
    }
  ]
};
///* This is from the first WOZ experiment
export const AvatarPersonality1 = {
  "title":"The Avatar's Personality",
  "instructions":<div>
  <p>Please rate how well you believe the following descriptions fit Saoirse's (the avatar's) personality from 1 (very wrong) to 5 (very right).</p>
  <p>If you don't understand a word, click the (?) next to it for an explanation. </p>
  <p>Saoirse seems...</p>
  </div>,
  "type":"scale",
  "start":"Very Wrong",
  "end":"Very Right",
  "options":["1","2","3","4","5"],
  "data":[
    { "id":"O1+_Curious",
			"question":"Curious",
      "description":"Having a strong desire to know about something",
    },
    { "id":"E1-_Shy",
			"question":"Shy",
      "description":"Nervous or embarrassed about meeting and speaking to other people",
    },
    { "id":"A1+_Patient",
			"question":"Patient",
      "description":"Able to wait for a long time or accept annoying behaviour or difficulties without becoming angry",
    },
    { "id":"O2-_Bored",
			"question":"Bored",
      "description":"Feeling tired and impatient because you have lost interest in somebody/something or because you have nothing to do",
    },
    { "id":"E2+_Assertive",
			"question":"Assertive",
      "description":"Expressing opinions or desires strongly and with confidence, so that people take notice",
    },
    { "id":"A2-_Annoyed",
			"question":"Annoyed",
      "description":"Slightly angry",
    },
    { "id":"O3+_Imaginative",
			"question":"Imaginative",
      "description":"Having or showing new and exciting ideas",
    },
    { "id":"E3-_Distant",
			"question":"Distant",
      "description":"Not wanting a close relationship with somebody",
    },
    { "id":"A3+_Caring",
			"question":"Caring",
      "description":"Kind, helpful and showing that you care about other people",
    },
    { "id":"O4-_Conservative",
			"question":"Conservative",
      "description":"Not liking great or sudden change/a preference for tradition",
    },
    { "id":"E4+_Outgoing",
			"question":"Outgoing",
      "description":"Liking to meet other people, enjoying their company and being friendly towards them",
    },
    { "id":"A4-_Demanding",
			"question":"Demanding",
      "description":"Expecting a lot of work or attention from others; not easily satisfied",
    }
  ]
};
//*/
export const Feedback2 = {
  "title":"Feedback Form",
  "data":[
    { "id":"FB_Enjoyment",
			"question":"Did you enjoy talking to Saoirse today?",
      "type":"scale",
      "start":"Not at all",
      "end":"Very much",
      "options":["1","2","3","4","5"],
    },
    { "id":"FB_Likes&Dislikes",
			"question":"What did you like/dislike about your conversation with Saoirse? ",
      "type":"longText"
    },
    { "id":"FB_ChatTopics",
			"question":"What did you talk about with Saoirse? ",
      "type":"longText"
    },
    { "id":"FB_TopicIdeas",
			"question":"What else would you like to discuss with Saoirse?  ",
      "type":"longText"
    }
  ]
};

export const Feedback1 = {
  "title":"Feedback Form",
  "data":[
    { "id":"FB_Enjoyment",
			"question":"Did you enjoy talking to Saoirse today?",
      "type":"radio",
      "options":["Yes","No"]
    },
    { "id":"FB_Likes&Dislikes",
			"question":"What did you like/dislike about your conversation with Saoirse? ",
      "type":"longText"
    },
    { "id":"FB_ChatTopics",
			"question":"What did you talk about with Saoirse? ",
      "type":"longText"
    },
    { "id":"FB_TopicIdeas",
			"question":"What else would you like to discuss with Saoirse?  ",
      "type":"longText"
    }
  ]
};

export const ConsentForm = { "title":"Consent Form",
  "data":["I am over 18 years old",
  "I understand that I will speak English during the experiment.",
  "I understand that all data I submit is anonymous.",
  "I understand that all data I submit will be securely stored and archived.",
  "I agree to participate in a research project conducted by Johanna Dobbriner from TU Dublin in Dublin, Ireland.",
  "I have received sufficient information about this research project and understand its purpose as well as my role in it.",
  "I consent to the video recordings and questionnaires I submit being used for analysis.",
  "I consent to the recorded interactions being used to train dialogue models.",
  "I understand that I can request the deletion of my data, completely or in part, at any time.or in part. This includes my survey answers, the video recording or my whole account.",
  "I understand that I can stop participating in this research project at any time.",
  "I consent to taking part in this research."
  ]
};

export const InfoSheet = {"title": "Experiment Information Sheet",
  "data":[
    { "id":"What is this research about?",
			"question":"What is this research about?",
    "answer":"The purpose of this experiment is for language learners to practice speaking English with a virtual tutor. I am interested in seeing how different personalities of the tutor influence the students’ interaction with it."},
    { "id":"Why are you doing this research?",
			"question":"Why are you doing this research?",
    "answer":"I know from experience when learning a new language that once you know some basic vocabulary and grammar, actually speaking that language can improve your skills a great deal. Since a real native speaker is not always available, I am trying to build a virtual replacement that language learners can practice talking to and enjoy interacting with."},
    { "id":"Why have I been invited to take part?",
			"question":"Why have I been invited to take part?",
    "answer":"You are an intermediate English language learner who is over 18. "},
    { "id":"What will happen if I decide to take part in this research study?",
			"question":"What will happen if I decide to take part in this research study?",
    "answer":"If you decide to participate, you will be able to practice your English with the avatar in a video chat. You will take part in a short assessment of your own personality traits, be asked to assess the avatar’s personality after three short conversations and be able to give feedback about your interactions with the avatar."},
    { "id":"How will the data be used?",
			"question":"How will the data be used?",
    "answer":"Your talk with the avatar will be recorded (video and audio) and to understand how you change your language pronunciation and production when interacting with the avatar. The recordings from the sentences you speak will be saved for later analysis. Your replies in the questionnaires will be statistically evaluated along with all other participants of this study."},
    { "id":"How will you protect my privacy?",
			"question":"How will you protect my privacy?",
    "answer":"You will choose a username which has no connection to your real name. In the study you will be referred to only by the basic demographic information you provide: age group, sex and native language."},
    { "id":"How is this research funded?",
			"question":"How is this research funded?",
    "answer":"This project is funded by Science Foundation Ireland Centre for Research Training in Digitally-Enhanced Reality (D-REAL)."},
    { "id":"What are the benefits of taking part in this research study?",
			"question":"What are the benefits of taking part in this research study?",
    "answer":"You will be able to practice your English. You may find it enjoyable to interact with an avatar who responds to your speech."},
    { "id":"What are the risks of taking part in this research study?",
			"question":"What are the risks of taking part in this research study?",
    "answer":"If you see negative expressions from the avatar you may feel bad. The video recordings of your conversation with the avatar are identifiable."},
    { "id":"What happens if I do not want to take part or if I change my mind? ",
			"question":"What happens if I do not want to take part or if I change my mind? ",
    "answer":"It is up to you to decide whether or not to take part. You can do that by clicking the “Participate” button on the experiment website. You can change your mind anytime and withdraw with no disadvantage.If you do decide to take part you will be given this information sheet to keep and will be asked to tick a box to confirm consent. You are free to withdraw from the experiment at any time without giving a reason and without detriment to yourself. If you wish to withdraw, you can send an email to "+EMAIL+" with the subject “withdraw from experiment” and clarify whether you only want your video and/or survey data removed or your entire account deleted. If you want a copy of your data, or wish your data to be deleted, you can state that in the email and I will follow your request."},
    { "id":"What happens to my data if I withdraw from the experiment?",
      "question":"What happens to my data if I withdraw from the experiment?",
      "answer":"All your data is stored in securely in a password-protected database. If I receive an email from you telling me you want to withdraw from the experiment and what data you would like to be removed, I will manually delete the entry associated with your email address in the database. Once your data is removed, I will notify you by email."},
    { "id":"What about the video recordings?",
			"question":"What about the video recordings?",
    "answer":"An essential part of my research is to record your interaction with the avatar. You should be comfortable with the recording process at all times and are free to request a recording stop at any time."},
    { "id":"Who has reviewed the research project?",
			"question":"Who has reviewed the research project?",
    "answer":"This project has been reviewed and approved by the Research Ethics Committee at TU Dublin."},
    { "id":"How will I find out what happens with this project?",
			"question":"How will I find out what happens with this project?",
    "answer":"This research is part of my PhD project. The results will be published and become part of my thesis. If you want to know more, please email "+EMAIL}
  ]
};
export const ExpInstructions1=
<div className="left" style={{maxWidth: "600px",margin: "auto"}}>
  <h1 className="title center">Experiment Instructions</h1>
  <p style={{ fontWeight: 'bold' }} className="center">Thank you for participating in this experiment.</p>
  <p style={{ fontWeight: 'bold' }} className="center">A few things to consider before you begin:</p>
  <h3>Your Device</h3>
  <p >To ensure that everything runs smoothly, please check that the following technological requirements are fulfilled: </p>
  <ul style={{ fontWeight: 'bold' }}>
    <li>Use Firefox or Chrome as your browser <i>(others may work but have not been tested)</i></li>
    <li>Your microphone and camera are working</li>
    <li>You have a stable internet connection</li>
    <li>Ideally, use headphones to minimize echo during the video call</li>
  </ul>
  <h3>Agenda</h3>
  <p>This experiment has 3 parts and should take you 20 - 25 minutes in total:</p>
  <ol style={{ fontWeight: 'bold' }}>
    <li>Participant survey <i>~5 min</i></li>
    <li>Videochat with the avatar <i>~10 min</i></li>
    <li>Feedback survey about the videochat <i>~5 min</i></li>
  </ol>
  <p> Now you are all set to begin the experiment.</p>
  <p><i>If you run into any difficulties or have a question during the experiment,
  please feel free to contact me at: <a href={"mailto:"+EMAIL}>{EMAIL}</a></i></p>
</div>

export const ExpInstructions2=
<div className="left" style={{maxWidth: "600px",margin: "auto"}}>
  <h1 className="title center">Experiment Instructions</h1>
  <p style={{ fontWeight: 'bold' }} className="center">Thank you for participating in this experiment.</p>
  <p style={{ fontWeight: 'bold' }} className="center">A few things to consider before you begin:</p>
  <h3>Setup</h3>
  <p >To ensure that everything runs smoothly, please put on the headset provided to you and do not close or refresh this tab in your browser.</p>
  <h3>Agenda</h3>
  <p>This experiment has 3 parts and should take you 20 - 25 minutes in total:</p>
  <ol style={{ fontWeight: 'bold' }}>
    <li>Participant survey <i>~5 min</i></li>
    <li>Videochat with the avatar <i>~10 min</i></li>
    <li>Feedback survey about the videochat <i>~5 min</i></li>
  </ol>
  <p> Now you are all set to begin the experiment.</p>
  <p><i>If you run into any difficulties or have a question during the experiment,
  please feel free ask the researcher who is running this experiment.</i></p>
</div>

export const Intro3=
<div className="left" style={{maxWidth: "600px",margin: "auto"}}>
  <h1 className="title center">Experiment Instructions</h1>
  <p style={{ fontWeight: 'bold' }} className="center">Thank you for participating in this experiment.</p>
  <p style={{ fontWeight: 'bold' }} className="center">Please click the Next button to continue.</p>
</div>

export const Survey3 = {
  "title":"Daily Survey",
  "data":[
    { "id":"FavColour",
			"question":"What is your favourite colour?",
      "type":"radio",
      "options":["Red","Orange","Yellow","Green","Blue","Purple","Pink","Brown"]
    },
    { "id":"CurrWeather",
			"question":"What is the current weather? ",
      "type":"radio",
      "options":["Sunny","Rainy","Windy","Cloudy"]
    }
  ]
};

export const AllExperiments = {
  "ex1":{
    "name":"WOZ Experiment",
    "pages": ["start","profile","personality","chat","avatar","feedback"],
    "parts": [ExpInstructions1,Profile,Personality,"",AvatarPersonality1,Feedback1],
    "types": ["HTML","Form","Form","VideoChat","Form","Form"]
  },
  "ex2":{
    "name":"Bot Experiment",
    "pages": ["start","profile","personality","chat","avatar","feedback"],
    "parts": [ExpInstructions2,Profile,Personality,BotChat,AvatarPersonality2,Feedback2],
    "types": ["HTML","Form","Form","HTMLByGroup","Form","Form"]
  },
  "ex3":{
    "name":"New Experiment",
    "pages":["start","metadata"],
    "parts": [Intro3,Survey3],
    "types": ["HTML","Form"]
  }

};
